import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { CoronaOfficeAttendance } from '../entities/corona-office-attendance.entity';
import { environment } from '../../environments/environment';
import { CoronaTestResult } from '../entities/corona-test-result.entity';
import { CoronaTestResultFile } from '../entities/corona-test-result-file.entity';

@Injectable({providedIn: 'root'})
export class CoronaService {
  attendances = [] as CoronaOfficeAttendance[];
  testResults = [] as CoronaTestResult[];
  localDB = environment.localDb;
  delay = ms => new Promise(res => setTimeout(res, ms));

  constructor(private api: ApiService) {
    const tempAtt = localStorage.getItem('attendances');
    if (tempAtt) {
      const storedItems = JSON.parse(tempAtt) as CoronaOfficeAttendance[];
      console.log('Attendance found in local storage -> reusing');
      this.attendances = [...this.attendances, ...storedItems];
    }

    const tempResults = localStorage.getItem('testResults');
    if (tempResults) {
      const storedItems = JSON.parse(tempResults) as CoronaTestResult[];
      console.log('TestResult found in local storage -> reusing');
      this.testResults = [...this.testResults, ...storedItems];
    }
  }

    async getMyAttendances(): Promise<CoronaOfficeAttendance[]> {
      if (this.localDB) {
        await this.delay(1000);
        return [...this.attendances];
      }
      else {
        const items = await this.api.get('corona/officeAttendances/my');
        const result = new Array<CoronaOfficeAttendance>();
        for (const item of items) {
          const p = Object.assign(new CoronaOfficeAttendance(), item);
          result.push(p);
        }
        return result;
      }
    }

    async getAllAttendances(): Promise<CoronaOfficeAttendance[]> {
      const items = await this.api.get('corona/officeAttendances');
      const result = new Array<CoronaOfficeAttendance>();
      for (const item of items) {
        const p = Object.assign(new CoronaOfficeAttendance(), item);
        result.push(p);
      }
      return result;
    }

    async postAttendance(attendance: CoronaOfficeAttendance) {
      if (this.localDB) {
        this.attendances.push(attendance);
        await this.delay(1000);
        localStorage.setItem('attendances', JSON.stringify(this.attendances));
      }
      else {
        const result: any = await this.api.post('corona/officeAttendances/', attendance);
        // await this.api.post('corona/attendances/' + result.id + '/signature', attendance.signature);
      }
    }
    ///////////////////////////////////////////////////////////////////////////

  async getMyTests(): Promise<CoronaTestResult[]> {
    if (this.localDB) {
      await this.delay(1000);
      return [...this.testResults];
    }
    else {
      const items = await this.api.get('corona/testResults/my');
      const result = new Array<CoronaTestResult>();
      for (const item of items) {
        const p = Object.assign(new CoronaTestResult(), item);
        result.push(p);
      }
      return result;
    }
  }

  async getAllTests(): Promise<CoronaTestResult[]> {
    const items = await this.api.get('corona/testResults');
    const result = new Array<CoronaTestResult>();
    for (const item of items) {
      const p = Object.assign(new CoronaTestResult(), item);
      result.push(p);
    }
    return result;
  }

  async postTest(testResult: CoronaTestResult) {
    if (this.localDB) {
      this.testResults.push(testResult);
      await this.delay(1000);
      localStorage.setItem('testResults', JSON.stringify(this.testResults));
    }
    else {
      const files = testResult.files;
      const testResultToUpload = {...testResult};
      testResultToUpload.files = [];
      const result: any = await this.api.post('corona/testResults', testResultToUpload);
      for (const file of files) {
        await this.api.post('corona/testResults/' + result.id + '/files', file);
      }
      //await this.api.post('testResults/' + result.id + '/signature', testResult.signature);
    }
  }

  async getFiles(testResult: CoronaTestResult): Promise<CoronaTestResultFile[]> {
    if (this.localDB) {
      this.testResults.push(testResult);
      await this.delay(1000);
      return testResult.files;
    }
    else {
      return await this.api.get('corona/testResults/' + testResult.id + '/files');
    }
  }

}
